import {
  IDocumentMetadataWithFieldMetadataDto,
  IKksValidationResultDto,
} from 'types';

export enum MetadataGridEditorMode {
  METADATA_INSPECTION = 'metadataInspection',
  QUALITY_CHECK = 'qualityCheck',
}

export type ColumnTypeAndEditor = Pick<
  Column,
  'columnType' | 'editor' | 'cellTemplate' | 'labelKey' | 'valueKey'
>;

export type MetadataGridEditorProvider = {
  fieldInfo: () => IDocumentMetadataWithFieldMetadataDto[] | undefined;
  kksValidation: () => IKksValidationResultDto;
  projectLocation: () => string;
};

export type SelectSource = {
  label: string;
  value: string;
};

export type Column = {
  columnType?: ColumnType;
  editor?: any;
  prop: string;
  name: string;
  labelKey?: 'label';
  valueKey?: 'value';
  source?: SelectSource[];
  cellProperties?: ({ prop, model }: { prop: string; model: any }) => object;
  readonly: boolean;
  pin?: ColumnPin;
  cellTemplate?: (createElement: any, props: any, additionalData?: any) => any;
  size?: number;
};

export enum ColumnType {
  DATE = 'date',
  NUMBER = 'number',
  SELECT = 'select',
  STRING = 'string',
}

export enum ColumnPin {
  COL_PIN_START = 'colPinStart',
}

export type DocumentObjectIdsAndUploadIds = {
  documentObjectId: string;
  uploadId: string;
};

export type KksBeforeAcceptance = {
  [documentId: string]: {
    KKS?: string;
    checkBotEstablishedKKS?: string[];
    dccProposals?: string[];
    dccAiPrediction?: { dcc: string; confidence: string; reasoning: string };
  };
};

export type RowDefinition = {
  type: 'rgRow';
  index: number;
  size: number;
};

export interface DccTag {
  value: string;
  label: string;
  isAi: boolean;
}
